import {
  ComponentRendering,
  HtmlElementRendering,
  PlaceholderComponentProps,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentType } from 'react';

const PARTIAL_DESIGN_PLACHOLDER = 'PartialDesignDynamicPlaceholder';
const isComponentRendering = (o: any): o is ComponentRendering => 'componentName' in o;

const replaceWithPartialDesign = (renderings: Array<ComponentRendering | HtmlElementRendering>) => {
  const partialDesign = renderings.find(
    (r) => isComponentRendering(r) && r.componentName === PARTIAL_DESIGN_PLACHOLDER
  );
  const newRenderings = partialDesign ? [partialDesign] : renderings;
  return newRenderings;
};

/**
 * HOC which checks if the `PartialDesignDynamicPlaceholder` component is present among the placeholders
 * and keeps only that if it is, leaves them intact otherwise.
 */
export const WithPartialDesignPreference = <
  P extends { name: string; rendering: PlaceholderComponentProps['rendering'] }
>(
  Component: ComponentType<P>
) => {
  const wrapper = (props: P) => {
    const { rendering, name } = props;
    let newRendering = { ...rendering };
    if (newRendering.placeholders?.[name]) {
      const newPlaceholders = {
        ...newRendering.placeholders,
        [name]: replaceWithPartialDesign(newRendering.placeholders[name]),
      };
      newRendering = {
        ...newRendering,
        placeholders: newPlaceholders,
      };
    }
    return <Component {...props} rendering={newRendering} />;
  };
  return wrapper;
};
